import { A11CommerceConfig } from '@stocker/commerce-config'

export const showShippingCost = (shippingCost: number) => {
  return shippingCost !== 0 || A11CommerceConfig.showShippingPriceIfFree
}
